import { render, staticRenderFns } from "./otherConfiguration.vue?vue&type=template&id=65852977&scoped=true"
import script from "./otherConfiguration.vue?vue&type=script&lang=js"
export * from "./otherConfiguration.vue?vue&type=script&lang=js"
import style0 from "./otherConfiguration.vue?vue&type=style&index=0&id=65852977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65852977",
  null
  
)

export default component.exports